import React, { useEffect, useState } from "react";
import { get,put } from "../../config/axios";
import Layout from "../../layout/Main/Layout";
import { Typography } from "@mui/material";
import CustomTable from "../../components/Custom/Table/CustomTable";
import { ReportTableColumn } from "../../constants/ReportPage";
import { toastMessage } from "../../utils/toastMessage";
const Report=()=>{
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [loading, setLoading] = useState(true);
    const [reportData,setReportData]=useState([])
    const fetchTransaction=async()=>{
        try {
            setLoading(true)
            const res=await get(`/api/dashboard/features/ReportHistory?page=${page}`)
            setReportData(res.data)
            setLoading(false)
            setPageCount(res?.totalPages);
        } catch (err) {
            console.log("Error",err)
            setLoading(true)
        }
    }

     const handleActive = async (id, active) => {
        setLoading(true);
        let response = await put(`/api/dashboard/features/updatereport?id=${id}`,
          {
            status: active,
          }
        );
        if(response.status === 200){
            // window.location.reload()
            toastMessage(response?.message, "success");

        }
        // setMessage(response.message);
        setLoading(false);
        // fetchUsers("");
      };
    useEffect(()=>{
        fetchTransaction()
    },[page])
    const handleChange=(page)=>{
        setPage(page)
    }
    return (
        <div>
         <Layout>
            <div style={{ padding: "1rem" }}>
              <Typography variant="h5">Complaints History</Typography>
              <CustomTable
                data={reportData}
                columns={ReportTableColumn}
                handleEdit={()=>{}}
                handleDelete={()=>{}}
                handleStatus={()=>{}}
                handleActive={(row, active) => handleActive(row, active)}
                handlePageChange={(page) => handleChange(page)}
                pageNumber={page}
                pageCount={pageCount}
                loading={loading}
            />
            </div>
          </Layout>
        </div>
    )
}
export default Report;